import { render, staticRenderFns } from "./supMenu.vue?vue&type=template&id=2dd8149e"
import script from "./supMenu.vue?vue&type=script&lang=js"
export * from "./supMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports